import React, { ReactNode, useEffect, useMemo } from 'react';
import { useLocation, Link as RouterLink } from 'react-router-dom';
import { Typography, Button } from '@mui/material';

import { PATH_DASHBOARD } from '../../routes/paths';
import useSubscriptions from 'src/hooks/useSubscriptions';
import { StyledTopAlert } from './styles';
import usePage from 'src/hooks/usePage';
import { CubesIcon } from 'src/theme/overrides/CustomIcons';

//
//

const TopAlertMessage = () => {
  const { pathname } = useLocation();
  const { isOpenAlert, setIsOpenAlert } = usePage();
  const {
    daysLeft,
    showStartTrialMessage,
    trialExpiresMessage,
    activateYourPlansMessage,
    startTrial,
    subscriptionsAreLoading,
    trialExpiresAt
  } = useSubscriptions();

  const onPlansPage = useMemo(() => pathname.includes(PATH_DASHBOARD.user.plans), [pathname])

  useEffect(() => {
    if (!subscriptionsAreLoading) {
      if ((showStartTrialMessage || trialExpiresMessage || activateYourPlansMessage) && !onPlansPage) {
        setIsOpenAlert(true);
      } else {
        setIsOpenAlert(false);
      }
    }
  }, [subscriptionsAreLoading, showStartTrialMessage, trialExpiresMessage, activateYourPlansMessage, setIsOpenAlert, onPlansPage])

  const TopAlertContainer = ({ children }: { children: ReactNode }) => {
    return isOpenAlert ?
      <StyledTopAlert
        onClose={() => setIsOpenAlert(false)}
        id='subscription-status-alert-message'
      >
        {children}
      </StyledTopAlert> : null
  }

  const ActionButton = () => (
    <Button
      component={RouterLink}
      to={PATH_DASHBOARD.user.plans}
      variant="contained"
      color='carbon'
      className='brandcube'
      endIcon={<CubesIcon size='small' />}
    >
      {trialExpiresAt ? "Upgrade today" : "Subscribe today"}
    </Button>
  );

  return (
    <>
      {showStartTrialMessage && isOpenAlert && (
        <TopAlertContainer>
          <Typography>
            <b>Start your free 14-day trial today.</b> Calculate your footprint and try purchasing from our offset portfolios.
          </Typography>
          <Button
            loading={subscriptionsAreLoading}
            onClick={startTrial}
            variant="contained"
            color='carbon'
            className='brandcube'
            endIcon={<CubesIcon size='small' />}
          >
            Start trial
          </Button>
        </TopAlertContainer>
      )}

      {trialExpiresMessage && isOpenAlert && (
        <TopAlertContainer>
          <Typography>
            <b>You have {daysLeft} days left in your trial.</b>{' '}
            Don't miss out - upgrade your plan now to keep enjoying our premium features.
          </Typography>
          <ActionButton />
        </TopAlertContainer>
      )}

      {activateYourPlansMessage && isOpenAlert && (
        <TopAlertContainer>
          <Typography>
            <b>You’re currently on a free account.</b>{' '}
            Activate on one of our paid plans to get access to premium features.
          </Typography>
          <ActionButton />
        </TopAlertContainer>
      )}
    </>
  );
};

export default TopAlertMessage;
